// v2.0 per-device prefs. Was: JSON file in Tauri app-data dir.
// Now: browser localStorage. Same public surface.
// OAuth token cache is retired — MSAL Browser owns sessionStorage caching
// for tokens; stored-token helpers become no-ops kept only for signature
// compatibility until callers are cleaned up.

export interface LensPrefs {
  language?: "en" | "nl";
  theme?: "light" | "dark";
  onedrive_path?: string;
  last_login?: string;
}

const PREFS_KEY = "lens_prefs";

export async function loadPrefs(): Promise<LensPrefs> {
  try {
    const raw = window.localStorage.getItem(PREFS_KEY);
    return raw ? (JSON.parse(raw) as LensPrefs) : {};
  } catch {
    return {};
  }
}

export async function savePrefs(patch: Partial<LensPrefs>): Promise<LensPrefs> {
  const current = await loadPrefs();
  const next = { ...current, ...patch };
  try {
    window.localStorage.setItem(PREFS_KEY, JSON.stringify(next));
  } catch (err) {
    console.warn("localStorage write failed", err);
  }
  return next;
}

// --- Retired: OAuth token cache. MSAL Browser handles this internally. ---

export interface StoredTokens {
  refresh_token: string;
}

export async function loadStoredTokens(): Promise<StoredTokens | null> {
  return null;
}

export async function saveStoredTokens(_tokens: StoredTokens): Promise<void> {
  // no-op
}

export async function clearStoredTokens(): Promise<void> {
  // no-op
}
